export default __webpack_public_path__ + "static/BrushedMist-51d3f21057599af338bb697db94a8708.svg";